import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type Props = { number: string; title: string; description: string; borderless?: boolean };

const Wrapper = styled.div<{ borderless?: boolean }>`
  display: flex;
  flex-direction: column;
  max-width: 455px;
  padding-block-end: 12px;
  margin-inline: 18px;
`;

const Number = styled(T.Title2)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-weight: 700;
  color: ${cbSemanticCssVars.surfaceMain};
  background-color: ${cbSemanticCssVars.textPrimary};
`;

const NumberWrapper = styled.div`
  background-color: ${cbSemanticCssVars.surfaceMain};
`;

const Title = styled(T.Title2)`
  font-weight: 700;
  margin-inline-start: 12px;
`;

const NumberTitleContainer = styled.div`
  display: flex;
  align-items: center;
  transform: translateX(-18px);
`;

const Description = styled(T.Body3)`
  margin-inline-start: 16px;
`;

const VerticalStep = ({ number, title, description, borderless }: Props) => {
  return (
    <Wrapper borderless={borderless}>
      <NumberTitleContainer>
        <NumberWrapper>
          <Number>{number}</Number>
        </NumberWrapper>

        <Title>{title}</Title>
      </NumberTitleContainer>

      <Description>{description}</Description>
    </Wrapper>
  );
};

export default VerticalStep;
